export default "__VITE_ASSET__DAFRJoe1__"